import React, { useState } from "react";
import "./Add_Cart_Modal.css";
import { Form, Modal } from "react-bootstrap";
import Dark_Blue_Btn from "../../Common-Component/common_btn/dark_blue_btn/Dark_Blue_Btn";
import Common_Goto_Cart_Card from "../../Common-Component/common_goto_cart_card/Common_Goto_Cart_Card";
import IncrementDecrementBtn from "../../Common-Component/Increment_Decrement_Btn/Increment_Decrement_Btn";
import Goto_cart_card from "../../Common-Component/Goto_cart_card/Goto_cart_card";

function Add_Cart_Modal(props) {
  const [showIncBtn, setShowIncBtn] = useState(false);

  const handleReason = async (d) => {
    await props.setReason(d);
    props.onHide();
  };

  return (
    <>
      <div className="Add_Cart_Modal" size="md">
        <Modal
          className="Add_Cart_Modal"
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className="main_content_div">
              <p className="product_name">Broccoli Varient</p>

              <div className="all_products_div">
                {Array?.from({ length: 3 })?.map((_, index) => {
                  return (
                    <div className="product_info_div">
                      <div className="prod_img_holder">
                        <img
                          src="/assets/Image/product/mango.png"
                          className="prod_img"
                        />
                      </div>

                      <div className="right_content_div">
                        <p className="qty_text">2 X 100g</p>

                        <div className="price_div">
                          <p className="selling_price">
                            ₹ 60.0 <span className="mrp_text">₹ 40.0</span>
                          </p>
                        </div>

                        {!showIncBtn ? (
                          <div className="add_btn_holder">
                            <Dark_Blue_Btn
                              btn_name="Add"
                              onClick={() => {
                                setShowIncBtn(true);
                              }}
                            />
                          </div>
                        ) : (
                          <div className="inc_btn_div">
                            <IncrementDecrementBtn />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              {showIncBtn && (
                <div className="floating_div">
                  <Goto_cart_card handleClose={() => {props.onHide()}}/>

                    
                </div>
              )}

            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Add_Cart_Modal;
